import { render } from "./branch-count.vue?vue&type=template&id=65d08e5c&scoped=true"
import script from "./branch-count.vue?vue&type=script&lang=js"
export * from "./branch-count.vue?vue&type=script&lang=js"

import "./branch-count.vue?vue&type=style&index=0&id=65d08e5c&scoped=scoped&lang=less"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65d08e5c"]])

export default __exports__